import { GetPendoData } from './../services/Pendo/GetPendoData';

const initTagManager = (response, clientId, dashboardType) => {
  /* eslint-disable */
  // BEGIN-NOSCAN
  pendoClientClassification = response.clientClassification ?? null;
  pendoClientStatus = response.clientStatus ?? null;
  pendoClientURL = response.clientUrl ?? null;
  pendoCompanyName = response.companyName ?? null;
  pendoDateCreated = response.dateCreated ?? null;
  pendoDesignatedWorkplace = response.designatedWorkplace ?? null;
  pendoEmployeeID = response.employeeId ?? null;
  pendoEmployeeType = response.employeeType ?? null;
  pendoEmploymentStatus = response.employmentStatus ?? null;
  pendoHasInsight = response.hasInsight ?? null;
  pendoHasInstacash = response.hasInstacash ?? null;
  GTMUniqueClientID = clientId ?? null;
  GTMUniqueEmployeeID = response.employeeId ?? null;
  GTMUniqueCompanyID = response.companyId ?? null;
  GTMUniqueDepartmentID = response.departmentId ?? null;
  GTMDashboardType = dashboardType ?? null;
  // END-NOSCAN
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    let f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-KVGM6PL');
};

export const getPendoData = (clientId, dashboardType) => {
  GetPendoData().then((response) => {
    initTagManager(response, clientId, dashboardType);
  });
};
